export default {
  current: {
    link_hls: null,
    link_rtmp: null,
    token_shared: null,
    owner_id: null,
    owner: {
      name: "",
      surname: "",
      id: "",
      avatar: ""
    }
  },

  streams: {
    data: [],
    status: null,
    page: 1,
    scope: null,
    filter: null,
    search: null,
    endOfList: false
  }
};
